/*
 * Copyright (c) 2026. Bluemate B.V.
 *
 * Blue square checkbox in the platform's dialog/card language (extracted from
 * the Add-notification channel cards, mirroring the multi-select's check).
 */
import './style/bluemateCheckbox.scss';

import {AwesomeIcon} from '@dvrd/dvr-controls';

import React, {ReactNode} from 'react';

import classNames from 'classnames';

interface Props {
    checked: boolean;
    /** Called with the NEW value. Omit for display-only boxes whose click is
     *  handled by a parent (e.g. a fully clickable card). */
    onCheck?: (checked: boolean) => void;
    label?: ReactNode;
    disabled?: boolean;
    className?: string;
}

export default function BluemateCheckbox(props: Props) {
    const {checked, onCheck, label, disabled, className} = props;

    function onClick() {
        if (disabled || !onCheck) return;
        onCheck(!checked);
    }

    return (
        <div
            className={classNames(
                'bluemate-checkbox',
                disabled && 'disabled',
                !!onCheck && !disabled && 'clickable',
                className
            )}
            onClick={onClick}
        >
            <div className={classNames('bluemate-checkbox-box', checked && 'checked')}>
                <AwesomeIcon name='check' />
            </div>
            {label !== undefined && <span className='bluemate-checkbox-label'>{label}</span>}
        </div>
    );
}
